export default function Sponsor({name, url, imgSrc}){
    return (
        <div className="col-lg-4 col-sm-6 mb-5 mb-lg-0" >
            <div className="card border-0 rounded-0 hover-shadow" style={{marginBottom:"30px"}}>
                <a href={url}>
                    <div className="card-body">
                <div className="card-title h4"><b>{name}</b></div>
            </div>
            <img className="card-img-top rounded-0" src={imgSrc.fields.file.url} alt={imgSrc.fields.title} />
            
            </a>
            </div>
        </div>
    );
}